import { DiscountVoucherModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class DiscountVoucherService extends ApiService<DiscountVoucherModel> {
	constructor() {
		super('discountvoucher');
	}
}

export default new DiscountVoucherService();
